import React, { useState, useRef, useEffect } from 'react';
import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';

const { Option } = Select;

const CitySearchSelect = ({ onChange }: { onChange?: (value: string) => void }) => {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [internalValue, setInternalValue] = useState('');
  const fetchRef = useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (searchValue: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);

      if (searchValue) {
        fetch(`https://api.openweathermap.org/data/2.5/find?q=${searchValue}&type=like&sort=population&cnt=5&appid=${WEATHER_API_KEY}&lang=zh_cn`)
          .then((response) => response.json())
          .then((body) => {
            if (fetchId !== fetchRef.current) return; // 防止旧的请求结果覆盖新的
            const cityOptions = body.list.map((city: { name: string; sys: { country: string }; id: number }) => ({
              label: `${city.name}, ${city.sys.country}`,
              value: city.id.toString(), // Antd Select 的 value 通常需要是 string
              ...city
            }));
            setOptions(cityOptions);
            setFetching(false);
          })
          .catch(() => {
            setFetching(false);
          });
      } else {
        setOptions([]);
        setFetching(false);
      }
    };
    return debounce(loadOptions, 500);
  }, []); // 依赖项为空，只在组件挂载时创建一次

  // 处理选中事件
  const handleChange = (selectedValue: string) => {
    // 更新内部状态
    setInternalValue(selectedValue);
    // 如果父组件传递了 onChange 回调，则调用它，将选中的值传出去
    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <Select
      showSearch
      value={internalValue}
      filterOption={false}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      onSearch={debounceFetcher}
      onChange={handleChange}
      placeholder="Input city name（ex: Beijing）"
      style={{ display: 'block' }}
    >
      {options.map((option: { value: string; label: string }) => (
        <Option key={option.value} value={option.value} label={option.label}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default CitySearchSelect;